function railCopy(step: string, compact = false) {
  const base = `prediction.v4.rail.steps.${step}`;
  return {
    title: `${base}.title`,
    subtitle: `${base}.subtitle`,
    running: `${base}.running`,
    bullets: [`${base}.bullet1`, `${base}.bullet2`],
    doneBullets: [`${base}.doneBullet1`, `${base}.doneBullet2`],
    compact,
  } as const;
}

export const V4_SIMULATION_MODULES = [
  {
    id: "request",
    label: "prediction.v4.modules.request",
    phases: ["scenario"],
    backdrop: "task",
    rail: railCopy("request"),
  },
  {
    id: "world",
    label: "prediction.v4.modules.world",
    phases: ["world_model", "agents"],
    backdrop: "world",
    rail: railCopy("world"),
  },
  {
    id: "sentiment",
    label: "prediction.v4.modules.sentiment",
    phases: ["souls", "mc_runner"],
    backdrop: "sentiment",
    rail: railCopy("sentiment"),
  },
  {
    id: "diffusion",
    label: "prediction.v4.modules.diffusion",
    phases: ["hawkes"],
    backdrop: "diffusion",
    rail: railCopy("diffusion"),
  },
  {
    id: "intent",
    label: "prediction.v4.modules.intent",
    phases: ["extras"],
    backdrop: "intent",
    rail: railCopy("intent"),
  },
  {
    id: "atlas",
    label: "prediction.v4.modules.atlas",
    phases: ["schema_outputs", "report"],
    backdrop: "atlas",
    rail: railCopy("atlas"),
  },
] as const;

export const V4_REPORT_SECTIONS = [
  {
    id: "overview",
    label: "results.v4.sections.overview",
    backdrop: "report-overview",
    rail: railCopy("overview"),
  },
  {
    id: "insights",
    label: "results.v4.sections.insights",
    backdrop: "report-insights",
    rail: railCopy("insights", true),
  },
  {
    id: "distribution",
    label: "results.v4.sections.distribution",
    backdrop: "report-distribution",
    rail: railCopy("distribution", true),
  },
  {
    id: "supplemental",
    label: "results.v4.sections.supplemental",
    backdrop: "report-supplemental",
    rail: railCopy("supplemental", true),
  },
] as const;

export const V4_WORKSPACE_STEPS = [
  ...V4_SIMULATION_MODULES,
  ...V4_REPORT_SECTIONS,
] as const;

export type V4SimulationSection =
  (typeof V4_SIMULATION_MODULES)[number]["id"];
export type V4ReportSection = (typeof V4_REPORT_SECTIONS)[number]["id"];
export type V4WorkspaceSection =
  (typeof V4_WORKSPACE_STEPS)[number]["id"];
